import { Pipe, PipeTransform } from '@angular/core';
import { FeeChargeRow, FeeEventOption } from '../../models/fee-config';

@Pipe({ name: 'feeOldEventLabel', pure: true })
export class FeeOldEventLabelPipe implements PipeTransform {
  transform(oldRow: FeeChargeRow | undefined, eventTypes: FeeEventOption[]): string {
    if (!oldRow?.eventType) return '';
    return eventTypes?.find(eventType => eventType.value === oldRow.eventType)?.label ?? oldRow.eventType;
  }
}
